// Define the pipeline object
const pipeline = {
    init: function () {
        AOS.init({ duration: 750 }); // Initialize AOS library
    }
};

// Document ready handler
jQuery(function ($) {
    pipeline.init(); // Initialize pipeline functionality

    // Handle sort order dropdown change
    $('#sort-order').on('change', function () {
        const selectedSortOrder = $(this).val();
        const url = new URL(window.location.href);

        // Update or remove the sort_order query parameter
        if (selectedSortOrder === 'default') {
            url.searchParams.delete('sort_order');
        } else {
            url.searchParams.set('sort_order', selectedSortOrder);
        }

        // Reload the page with the updated URL
        window.location.href = url.toString();
    });
});